module.exports = __webpack_public_path__ + "img/junior-high-school-course-title.9909140b.svg";